import { ConfigResponse } from './model';
import { Configs } from '../../models';

export const transformConfig = (config: ConfigResponse): Configs => ({
  daysToDisableAccount: {
    descriptionKey: 'daysToDisableAccountKey',
    value: config['days-to-disable-account-after-result-release'],
  },
  daysToLockInactivityAccount: {
    descriptionKey: 'daysToLockInactivityAccountKey',
    value: config['days-to-lock-inactivity-account'],
  },
  daysToEmailAdmin: {
    descriptionKey: 'daysToEmailAdminKey',
    value: config['days-to-email-admin-to-view-after-account-disabled'],
  },
  daysToInvalidateLink: {
    descriptionKey: 'daysToInvalidateLinkKey',
    value: config['days-to-invalidate-result-release-link-after-generating'],
  },
  timesOfMaxLogin: {
    descriptionKey: 'timesOfMaxLoginKey',
    value: config['times-of-max-login-try'],
  },
  minutesOfSessionTimeout: {
    descriptionKey: 'minutesOfSessionTimeoutKey',
    value: config['minutes-of-inactivity-before-session-timeout'],
  },
  minutesOfSessionTimeoutPrivilegedAdmin: {
    descriptionKey: 'minutesOfSessionTimeoutPrivilegedAdminKey',
    value: config['minutes-of-inactivity-before-session-timeout-privileged-admin'],
  },
  minutesOfSessionTimeoutNonPriviledgeAdmin: {
    descriptionKey: 'minutesOfSessionTimeoutNonPriviledgeAdminKey',
    value: config['minutes-of-inactivity-before-session-timeout-non-privileged-admin'],
  },
  daysOfPaymentLinkExpire: {
    descriptionKey: 'daysOfPaymentLinkExpireKey',
    value: config['days-before-payment-unique-link-expire'],
  },
  daysOfAccessLinkExpire: {
    descriptionKey: 'daysOfAccessLinkExpire',
    value: config['days-before-access-link-expire'],
  },
  timesOfMaxFailedAttempt: {
    descriptionKey: 'timesOfMaxFailedAttemptKey',
    value: config['times-of-max-failed-attempt'],
  },
  secondToWaitLogin: {
    descriptionKey: 'secondToWaitLoginKey',
    value: config['max-seconds-to-wait-to-retry-login'],
  },
  lastUpdatedBy: {
    descriptionKey: 'lastUpdatedBy',
    value: config.lastUpdatedBy,
  },
  lastUpdatedOn: {
    descriptionKey: 'lastUpdatedOn',
    value: config.lastUpdatedOn,
  },
  transactionLogUuid: {
    descriptionKey: 'transactionLogUuid',
    value: config.transactionLogUuid,
  },
});
